/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "寻日",
        "-2": "前天",
        "0": "今日",
        "1": "听日",
        "2": "后天",
        "future": {
          "other": "{0} 日后"
        },
        "past": {
          "other": "{0} 日前"
        }
      },
      "day-narrow": {
        "-1": "寻日",
        "-2": "前天",
        "0": "今日",
        "1": "听日",
        "2": "后天",
        "future": {
          "other": "{0} 日后"
        },
        "past": {
          "other": "{0} 日前"
        }
      },
      "day-short": {
        "-1": "寻日",
        "-2": "前天",
        "0": "今日",
        "1": "听日",
        "2": "后天",
        "future": {
          "other": "{0} 日后"
        },
        "past": {
          "other": "{0} 日前"
        }
      },
      "hour": {
        "0": "呢个小时",
        "future": {
          "other": "{0} 小时后"
        },
        "past": {
          "other": "{0} 小时前"
        }
      },
      "hour-narrow": {
        "0": "呢个小时",
        "future": {
          "other": "{0} 小时后"
        },
        "past": {
          "other": "{0} 小时前"
        }
      },
      "hour-short": {
        "0": "呢个小时",
        "future": {
          "other": "{0} 小时后"
        },
        "past": {
          "other": "{0} 小时前"
        }
      },
      "minute": {
        "0": "呢分钟",
        "future": {
          "other": "{0} 分钟后"
        },
        "past": {
          "other": "{0} 分钟前"
        }
      },
      "minute-narrow": {
        "0": "呢分钟",
        "future": {
          "other": "{0} 分钟后"
        },
        "past": {
          "other": "{0} 分钟前"
        }
      },
      "minute-short": {
        "0": "呢分钟",
        "future": {
          "other": "{0} 分钟后"
        },
        "past": {
          "other": "{0} 分钟前"
        }
      },
      "month": {
        "-1": "上个月",
        "0": "今个月",
        "1": "下个月",
        "future": {
          "other": "{0} 个月后"
        },
        "past": {
          "other": "{0} 个月前"
        }
      },
      "month-narrow": {
        "-1": "上个月",
        "0": "今个月",
        "1": "下个月",
        "future": {
          "other": "{0} 个月后"
        },
        "past": {
          "other": "{0} 个月前"
        }
      },
      "month-short": {
        "-1": "上个月",
        "0": "今个月",
        "1": "下个月",
        "future": {
          "other": "{0} 个月后"
        },
        "past": {
          "other": "{0} 个月前"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "上一季",
        "0": "今季",
        "1": "下一季",
        "future": {
          "other": "{0} 季后"
        },
        "past": {
          "other": "{0} 季前"
        }
      },
      "quarter-narrow": {
        "-1": "上季",
        "0": "今季",
        "1": "下季",
        "future": {
          "other": "{0} 季后"
        },
        "past": {
          "other": "{0} 季前"
        }
      },
      "quarter-short": {
        "-1": "上季",
        "0": "今季",
        "1": "下季",
        "future": {
          "other": "{0} 季后"
        },
        "past": {
          "other": "{0} 季前"
        }
      },
      "second": {
        "0": "宜家",
        "future": {
          "other": "{0} 秒后"
        },
        "past": {
          "other": "{0} 秒前"
        }
      },
      "second-narrow": {
        "0": "宜家",
        "future": {
          "other": "{0} 秒后"
        },
        "past": {
          "other": "{0} 秒前"
        }
      },
      "second-short": {
        "0": "宜家",
        "future": {
          "other": "{0} 秒后"
        },
        "past": {
          "other": "{0} 秒前"
        }
      },
      "week": {
        "-1": "上星期",
        "0": "今个星期",
        "1": "下星期",
        "future": {
          "other": "{0} 个星期后"
        },
        "past": {
          "other": "{0} 个星期前"
        }
      },
      "week-narrow": {
        "-1": "上星期",
        "0": "今个星期",
        "1": "下星期",
        "future": {
          "other": "{0} 个星期后"
        },
        "past": {
          "other": "{0} 个星期前"
        }
      },
      "week-short": {
        "-1": "上星期",
        "0": "今个星期",
        "1": "下星期",
        "future": {
          "other": "{0} 个星期后"
        },
        "past": {
          "other": "{0} 个星期前"
        }
      },
      "year": {
        "-1": "旧年",
        "0": "今年",
        "1": "下年",
        "future": {
          "other": "{0} 年后"
        },
        "past": {
          "other": "{0} 年前"
        }
      },
      "year-narrow": {
        "-1": "旧年",
        "0": "今年",
        "1": "下年",
        "future": {
          "other": "{0} 年后"
        },
        "past": {
          "other": "{0} 年前"
        }
      },
      "year-short": {
        "-1": "旧年",
        "0": "今年",
        "1": "下年",
        "future": {
          "other": "{0} 年后"
        },
        "past": {
          "other": "{0} 年前"
        }
      }
    },
    "locale": "yue-Hans"
  });
}